var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9545 16.5H7.04545C6.90079 16.5 6.76205 16.4425 6.65976 16.3402C6.55747 16.2379 6.5 16.0992 6.5 15.9545V7.04545C6.5 6.90079 6.55747 6.76205 6.65976 6.65976C6.76205 6.55747 6.90079 6.5 7.04545 6.5H15.9545C16.0992 6.5 16.2379 6.55747 16.3402 6.65976C16.4425 6.76205 16.5 6.90079 16.5 7.04545V15.9545C16.5 16.0992 16.4425 16.2379 16.3402 16.3402C16.2379 16.4425 16.0992 16.5 15.9545 16.5Z",
    stroke: "#7C8394",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.04545V2.04545C11.5 1.90079 11.4425 1.76205 11.3402 1.65976C11.2379 1.55747 11.0992 1.5 10.9545 1.5H2.04545C1.90079 1.5 1.76205 1.55747 1.65976 1.65976C1.55747 1.76205 1.5 1.90079 1.5 2.04545V10.9545C1.5 11.0992 1.55747 11.2379 1.65976 11.3402C1.76205 11.4425 1.90079 11.5 2.04545 11.5H6.04545",
    stroke: "#7C8394",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8c5257fdd1433e5728b9406c1eae2c8e.svg";
export { ForwardRef as ReactComponent };